import React from 'react'
import LinkWithScrollTop from './LinkWithScrollTop'

const LinkRenderer = ({ children, href }) => {
  // eslint-disable-next-line no-nested-ternary -- jsx use case ok
  return href.match(/^\//) ? (
    <LinkWithScrollTop to={href}>{children}</LinkWithScrollTop>
  ) : href.match(/^#/) ? (
    <a href={href}>{children}</a>
  ) : (
    <a href={href} rel="noreferrer noopener" target="_blank">
      {children}
    </a>
  )
}

export default LinkRenderer
